module.exports = __webpack_public_path__ + "img/google.08ea438e.svg";